import SailboatOffshore16 from '@carbon/icons-react/es/sailboat--offshore/16';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'hooks/use-translation';
import { Header } from './components';
import styles from './group.module.css';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

const IconWrapper = styled(Wrapper)`
  margin-right: var(--spacing-04);
  svg {
    color: var(--blue-60);
    width: 20px;
    height: 20px;
  }
`;

const StyledHeader = styled(Header)`
  cursor: default;
`;

export const TimeoffHeader = ({ children }) => {
  const timeOffLabel = useTranslation('settings.profile.timeoff.title');

  return (
    <StyledHeader className={styles.header}>
      <Wrapper>
        <IconWrapper>
          <SailboatOffshore16 />
        </IconWrapper>
        <div className={`${styles.title} ${styles.ellipsis}`}>
          {timeOffLabel}
        </div>
      </Wrapper>
      <Header.Hanger>{children}</Header.Hanger>
    </StyledHeader>
  );
};
